/* warehouse.icon.svg.js */

module.exports = {
    icon: `<svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="foreground-gl" d="M27.3977 0.917969H0.27832V3.52202H27.3977V0.917969Z" fill="#5D6F80"/>
  <path class="foreground-gl" d="M16.5398 10.0789H11.096V15.5227H16.5398V10.0789Z" fill="#5D6F80"/>
  <path class="foreground-gl" d="M20.1045 16.8071H14.6608V22.2509H20.1045V16.8071Z" fill="#5D6F80"/>
  <path class="foreground-gl" d="M7.6088 16.8071H13.0526V22.2509H7.6088V16.8071Z" fill="#5D6F80"/>
  <path class="foreground-gl" fill-rule="evenodd" clip-rule="evenodd" d="M2.28739 22.3053H25.3891L25.3889 4.49515H2.28711L2.28739 22.3053ZM6.28446 22.3052V8.24322H21.3508V22.3052H6.28446Z" fill="#5D6F80"/>
  </svg>  
    `
};
